import template from './template.html';

const dijagnoza = {
        name: 'dijagnoza',
        templateUrl: template,
        wrapper: ['validation', 'horizontalBootstrapLabel', 'bootstrapHasError'],
        defaultOptions : {
            templateOptions: {
                refresh: 'getDijagnoza($select.search, options)',
                refreshDelay: 700,
                options: [],
                optionsAttr: 'bs-options',
                ngOptions: 'option[to.valueProp] as option in to.options',
                valueProp: 'id',
                labelProp: 'naziv',
            },
            controller: ['$scope', 'Dijagnoza', function ($scope, Dijagnoza) {
                var params = {
                        limit: 50,
                        offset: 0,
                    };
                var init;
                $scope.getDijagnoza = function ($viewValue) {
                    params.search = $viewValue;
                    Dijagnoza.findAll(params).then(function (response) {
                        $scope.to.options = response;
                        if (angular.isDefined(init)) {
                            $scope.to.options.unshift(init);
                        }
                    });
                };

                Dijagnoza.find($scope.model[$scope.options.key]).then((response) => {
                    init = response;
                    $scope.to.options.push(init);
                });
            }]
        }
};

export {dijagnoza};



// WEBPACK FOOTER //
// ./app/components/common/forms/custom/dijagnoza/dijagnoza.js